import Phaser from 'phaser';
import { GAME_W, GAME_H, RENDER_SCALE } from '../config.ts';
import { UI } from '../../assets/palette.ts';
import { buildAllTextures } from '../../assets/index.ts';

/**
 * Generates every SVG at runtime, turns each into a Blob URL, and hands it to
 * Phaser's SVG loader to rasterize into a texture (at RENDER_SCALE for crisp
 * art). No image files ship with the game — the art IS the code.
 */
export class BootScene extends Phaser.Scene {
  private blobUrls: string[] = [];

  constructor() {
    super('Boot');
  }

  preload(): void {
    this.drawLoadingBar();

    const textures = buildAllTextures();
    for (const [key, spec] of Object.entries(textures)) {
      const blob = new Blob([spec.svg], { type: 'image/svg+xml' });
      const url = URL.createObjectURL(blob);
      this.blobUrls.push(url);
      // Rasterize at RENDER_SCALE × the SVG's intrinsic (logical) size.
      this.load.svg(key, url, { scale: RENDER_SCALE });
    }
  }

  create(): void {
    // Blob URLs are no longer needed once textures are decoded.
    for (const url of this.blobUrls) URL.revokeObjectURL(url);
    this.blobUrls = [];
    this.scene.start('Menu');
  }

  /** A tiny, wordless loading bar (it flashes by, but avoids a blank frame). */
  private drawLoadingBar(): void {
    const w = 420;
    const h = 36;
    const x = (GAME_W - w) / 2;
    const y = GAME_H / 2 - h / 2;
    this.add.rectangle(GAME_W / 2, GAME_H / 2, GAME_W, GAME_H, 0xcdeaf6).setDepth(-1);
    const frame = this.add.graphics();
    frame.lineStyle(6, 0x4a3f3a, 1).strokeRoundedRect(x, y, w, h, 18);
    const bar = this.add.graphics();
    this.load.on('progress', (p: number) => {
      bar.clear();
      bar.fillStyle(Phaser.Display.Color.HexStringToColor(UI.star).color, 1);
      bar.fillRoundedRect(x + 6, y + 6, Math.max(0, (w - 12) * p), h - 12, 12);
    });
  }
}
